import { HorizBox, Pad } from 'component/basics';
import { HelpBubble } from 'component/help';
import { UtilityText } from 'component/text';
import { View } from 'react-native';
import { CLICK, component, demoFile, story } from 'system/demo';

demoFile('component/help', {
    designUrl:
        'https://www.figma.com/design/qbH103GBR3McZqhUp7O9fA/Onboarding-%26-Login-%26-Community-Guidelines---Testing?node-id=446-13588&node-type=frame&t=WoTasw1N3LUhU58o-0',
});

function HelpBubbleDemo() {
    return (
        <View>
            <UtilityText text='Help Below Left' />
            <HelpBubble condition={true} helpKey='below' pointer text='This is a help bubble shown below and to the left' />
            <Pad size={180} />
            <HelpBubble
                above
                condition={true}
                helpKey='above'
                right
                text='This is a help bubble shown above and to the right'
                titleText='Help Title'
            />
            <HorizBox spread>
                <Pad />
                <UtilityText text='Help Above Right' />
            </HorizBox>
            <UtilityText text='Help Wide' />
            <HelpBubble condition={true} helpKey='wide' text='This is a help bubble shown wide' wide />
            <Pad />
        </View>
    );
}

component('HelpBubble', HelpBubbleDemo, {}, [story('Close Below', [CLICK('close-below')]), story('Close Above', [CLICK('close-above')])]);
